var _path, _path2, _path3, _line, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJourneySmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 64,
    viewBox: "0 0 298 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 63C86.3137 63 89 60.3137 89 57C89 53.6863 86.3137 51 83 51C79.6863 51 77 53.6863 77 57C77 60.3137 79.6863 63 83 63Z",
    fill: "#686868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145 63C148.314 63 151 60.3137 151 57C151 53.6863 148.314 51 145 51C141.686 51 139 53.6863 139 57C139 60.3137 141.686 63 145 63Z",
    fill: "#686868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209 63C212.314 63 215 60.3137 215 57C215 53.6863 212.314 51 209 51C205.686 51 203 53.6863 203 57C203 60.3137 205.686 63 209 63Z",
    fill: "#686868"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 57.25,
    x2: 277,
    y2: 57.25,
    stroke: "#686868",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 63C20.3137 63 23 60.3137 23 57C23 53.6863 20.3137 51 17 51C13.6863 51 11 53.6863 11 57C11 60.3137 13.6863 63 17 63Z",
    fill: "#F03040"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M284.5 60C286.985 60 289 57.9853 289 55.5C289 53.0147 286.985 51 284.5 51C282.015 51 280 53.0147 280 55.5C280 57.9853 282.015 60 284.5 60Z",
    fill: "#F03040"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284.5 63C288.642 63 292 59.6421 292 55.5C292 51.3579 288.642 48 284.5 48C280.358 48 277 51.3579 277 55.5C277 59.6421 280.358 63 284.5 63Z",
    stroke: "#F03040"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5145 20.185L96.1451 21.693L93.094 5.67996L92.2727 5H88.0583L87.2353 5.68833L83.9459 23.9595L82.2447 25.1555L82.2364 20.8901L80.9208 20.2068L73.8727 25.1396V20.8909L72.5872 20.185L63.3872 26.0396L63 26.7455V40.9636L63.8364 41.8H98.9636L99.8 40.9636V20.8909L98.5145 20.185ZM88.7575 6.67272H91.5811L94.6263 22.6598L90.6 25.2216V20.8909L89.2827 20.2068L85.8921 22.5904L88.7575 6.67272ZM64.6727 40.1273H98.1272V22.4148L90.2127 27.4513L88.9272 26.7454V22.5009L81.8925 27.4472L80.5753 26.7647L80.5669 22.495L73.5155 27.4304L72.1999 26.7454V22.4148L64.6727 27.2046V40.1273Z",
    fill: "#686868"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.0181,
    y: 31.7636,
    width: 1.67273,
    height: 3.34545,
    fill: "#686868"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 31.7636,
    width: 1.67273,
    height: 3.34545,
    fill: "#686868"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3818,
    y: 31.7636,
    width: 1.67273,
    height: 3.34545,
    fill: "#686868"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.5637,
    y: 31.7636,
    width: 1.67273,
    height: 3.34545,
    fill: "#686868"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7454,
    y: 31.7636,
    width: 1.67273,
    height: 3.34545,
    fill: "#686868"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88.9272,
    y: 31.7636,
    width: 1.67273,
    height: 3.34545,
    fill: "#686868"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93.1091,
    y: 31.7636,
    width: 1.67273,
    height: 3.34545,
    fill: "#686868"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.797 35.5321H155.131V39.2221H158.797V41.0964H155.131V41.975L154.123 43C153.26 43 152.386 43.041 151.471 43C151.131 42.9506 150.815 42.7949 150.568 42.5549C149.751 41.7993 148.987 40.991 148.193 40.212C148.013 40.0448 147.871 39.8395 147.778 39.6108C147.685 39.382 147.643 39.1354 147.655 38.8883V38.3143H131.944L131 37.3127V31.8304L131.967 30.8289H143.937V24.386H133.803L132.853 23.3493V2.99571L133.82 2H156.011L156.932 2.95471V23.3903L155.982 24.3684H145.871V31.7309L144.898 32.7441H132.911V36.3873H147.655V35.9187C147.644 35.6655 147.688 35.4129 147.783 35.1784C147.878 34.9438 148.022 34.7328 148.205 34.5599C148.981 33.7984 149.745 33.0194 150.521 32.217C150.82 31.9168 151.224 31.7483 151.645 31.7484C152.479 31.7484 153.313 31.7484 154.158 31.7484L155.108 32.7851V33.6286H158.797V35.5321ZM155.05 22.4473V3.93871H134.741V22.4473H155.05ZM153.191 41.0613V33.6871H151.801L149.56 35.9714V38.8063L151.795 41.0789L153.191 41.0613Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.713 12.2442H146.757L147.562 13.6616L144.771 18.3473L143.161 17.3633L145.078 14.136H143.051L142.235 12.7069L145.026 8.02115L146.636 9.02858L144.713 12.2442Z",
    fill: "#686868"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.777 1.34401L215.42 20.08H220.874L221.734 21.4415L212.213 41.4353L211.353 41.978H208.497L207.554 40.8907L209.303 28.6488H204.689L203.746 27.5625L207.525 0.904143L208.467 0.0863037H220.874L221.777 1.34401ZM209.595 40.0737H210.752L219.366 21.9841H214.091L213.189 20.7264L219.546 1.99038H209.294L205.785 26.7445H210.401L211.344 27.8318L209.595 40.0737Z",
    fill: "#686868"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297.102 3H270.922L270 3.90615V40.6551L270.91 41.5437H297.032L298 40.62V3.96462L297.102 3ZM271.861 4.88831H283.043V31.7806H271.884C271.884 30.512 271.861 13.488 271.861 4.88831ZM271.861 39.6495V33.7157H283.049V39.6554L271.861 39.6495ZM284.957 4.91754H296.128C296.128 6.43169 296.128 30.5295 296.128 31.7806H284.974L284.957 4.91754ZM284.957 39.6378V33.7098H296.128V39.6378H284.957Z",
    fill: "#686868"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280.564 14.3883V10.0622L279.631 9.11508H275.25L274.357 10.0154V14.3942L275.291 15.3412H279.613L280.564 14.3883ZM276.236 13.4412V11.0268H278.651V13.4412H276.236Z",
    fill: "#686868"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280.582 18.7203H278.686V24.1046H280.582V18.7203Z",
    fill: "#686868"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.314 18.7203H287.418V24.1046H289.314V18.7203Z",
    fill: "#686868"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5.39999C8.07464 5.39999 0 13.4746 0 23.4C0 33.3254 8.07464 41.4 18 41.4C27.9254 41.4 36 33.3254 36 23.4C36 13.4746 27.9254 5.39999 18 5.39999ZM17.1817 15.1846C15.4529 15.1118 13.7707 14.8132 12.1638 14.2903C13.4009 12.0534 15.1003 10.0734 17.1817 8.47633V15.1846ZM17.1818 22.5818V16.8194C15.219 16.74 13.284 16.3874 11.4365 15.7615C10.4948 17.8855 9.9458 20.1911 9.84352 22.5818H17.1818ZM17.1817 24.2182V29.9806C15.2255 30.06 13.2962 30.411 11.4545 31.0328C10.507 28.9047 9.94983 26.5983 9.8451 24.2182H17.1817ZM17.182 38.3293V31.6153C15.4605 31.6882 13.7865 31.9852 12.1861 32.5031C13.4281 34.7465 15.1177 36.7404 17.182 38.3293ZM18.8183 38.3236V31.6153C20.5471 31.6882 22.2293 31.9868 23.8362 32.5104C22.5991 34.7465 20.9006 36.7265 18.8183 38.3236ZM18.8183 24.2182V29.9806C20.7811 30.06 22.7161 30.4126 24.5627 31.0386C25.5053 28.9146 26.0543 26.6089 26.1566 24.2182H18.8183ZM18.8183 22.5818V16.8194C20.7811 16.74 22.7161 16.3866 24.5627 15.7615C25.5045 17.8855 26.0535 20.1911 26.1557 22.5818H18.8183ZM18.8183 8.47633V15.1846C20.5471 15.1118 22.2293 14.8123 23.8362 14.2895C22.5991 12.0534 20.8997 10.0734 18.8183 8.47633ZM19.7565 7.13457C23.3957 7.52484 26.6717 9.12111 29.2016 11.5037C28.0037 12.3947 26.7282 13.1351 25.3847 13.7103C24.0192 11.1715 22.112 8.9272 19.7565 7.13457ZM6.79823 11.5028C7.99605 12.3946 9.27241 13.1351 10.615 13.7094C11.9806 11.1714 13.8878 8.92718 16.2417 7.13372C12.6032 7.52481 9.32723 9.12027 6.79823 11.5028ZM9.90894 15.1724C8.89603 17.4813 8.3094 19.9857 8.20713 22.5818H1.67803C1.86622 18.8076 3.32831 15.3704 5.65603 12.6908C6.97331 13.6898 8.40022 14.5236 9.90894 15.1724ZM9.92694 31.6203C8.90749 29.3081 8.31431 26.802 8.20958 24.2182H1.67803C1.8654 27.9925 3.32831 31.4296 5.65685 34.1084C6.97903 33.1061 8.41167 32.2707 9.92694 31.6203ZM10.6404 33.0799C12.01 35.6245 13.9058 37.881 16.2376 39.6646C12.6008 39.2735 9.32641 37.6781 6.79823 35.2964C8.00423 34.3996 9.28877 33.6567 10.6404 33.0799ZM29.201 35.2972C28.0032 34.4054 26.7269 33.6649 25.3842 33.0906C24.0195 35.6286 22.1123 37.8728 19.7576 39.6663C23.396 39.276 26.672 37.6797 29.201 35.2972ZM26.0902 31.6276C27.1031 29.3187 27.6898 26.8143 27.792 24.2182H34.3219C34.1338 27.9925 32.6717 31.4296 30.3439 34.1092C29.0267 33.111 27.5998 32.2765 26.0902 31.6276ZM26.0909 15.1724C27.1038 17.4813 27.6904 19.9866 27.7927 22.5818H34.3218C34.1336 18.8076 32.6715 15.3704 30.3438 12.6908C29.0273 13.689 27.5996 14.5236 26.0909 15.1724Z",
    fill: "#1F1F1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.7966,
    height: 41,
    fill: "white",
    transform: "translate(131 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneySmall);
export default __webpack_public_path__ + "static/media/journey-small.25f56419222b3d65c23d24fc79168eb7.svg";
export { ForwardRef as ReactComponent };